import { ERROR_404 } from '../../constants/localizations/app';
import Text from '../Text';
import ErrorPage from './ErrorPage';

const Error404 = () => (
  <ErrorPage httpStatusCode={404} message={<Text name={ERROR_404} />} />
);

export default Error404;
